module.exports = __webpack_public_path__ + "img/select2-spinner.8ee7fcb9.gif";